import API from '@/api/index';
import * as Auth from '@/utils/auth';

const user = {
  state: {
    token: Auth.getAccessToken(),
    refreshToken: Auth.getRefreshToken(),
    loggedUser: Auth.getLoggedUser(),
    roles: [],
    firebaseCloudMessageToken: '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
      Auth.setAccessToken(token);
    },
    SET_LOGGED_USER: (state, loggedUser) => {
      Auth.setLoggedUser(loggedUser);
      state.loggedUser = loggedUser;
    },
    SET_ROLES: (state, roles) => { state.roles = roles },
    SET_FCM_TOKEN: (state, token) => { state.firebaseCloudMessageToken = token },

    SET_REFRESH_TOKEN: (state, refreshToken) => {
      state.refreshToken = refreshToken;
      Auth.setRefreshToken(refreshToken);
    },
    SET_CLIENT_ID: (state, clientID) => {
      state.clientID = clientID;
      Auth.setClientId(clientID);
    }
  },

  actions: {
    loginByUsername ({ commit, dispatch }, loginModel) {
      return new Promise((resolve, reject) => {
        API.user
          .loginByUsername(loginModel)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let token = result.data.json;
              commit('SET_TOKEN', token);

              dispatch('getUserInfo').then(res => {
                if (res) resolve(res);
                else reject(res);
              });
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        API.user
          .getUserInfo(state.token)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let user = result.data;
              commit('SET_LOGGED_USER', user);
              resolve(result);
            } else {
              reject(response.data.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    resetPassword ({ state }, userId) {
      return new Promise((resolve, reject) => {
        API.user
          .resetPassword(userId)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    changePassword ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .changePassword(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },


    forceLogin ({ state }, userId) {
      return new Promise((resolve, reject) => {
        API.user
          .forceLogin(userId)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    checkPhone ({ state }, phoneNumber) {
      return new Promise((resolve, reject) => {
        API.account
          .checkPhone(phoneNumber)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    checkEmail ({ state }, email) {
      return new Promise((resolve, reject) => {
        API.account
          .checkEmail(email)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    createUser ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .createUser(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              resolve(result.data);
            } else {
              reject(result.code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    logOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        commit('SET_LOGGED_USER', '');

        Auth.removeToken();
        Auth.removeClientId();
        resolve();
      });
    },

    getRoles ({ commit }) {
      return new Promise((resolve, reject) => {
        API.user
          .getRoles()
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) resolve(result.data.data || result.data);
            else reject(result);
          })
          .catch(error => reject(error));
      });
    },

    getGroupRoles ({ commit }) {
      return new Promise((resolve, reject) => {
        API.user
          .getGroupRoles()
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) resolve(result.data.data || result.data);
            else reject(result);
          })
          .catch(error => reject(error));
      });
    },

    setRoles ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .setRoles(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) resolve(result.data);
            else reject(result);
          })
          .catch(error => reject(error));
      });
    },

    // refreshToken: ({ commit }, token) => commit('SET_TOKEN', token),
    setFCMToken: ({ commit }, token) => commit('SET_FCM_TOKEN', token),

    refreshToken ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .refreshToken(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let token = result.data.accessToken;
              commit('SET_TOKEN', token);
              commit('SET_TOKEN_TYPE', result.data.tokenType);
              commit('SET_REFRESH_TOKEN', result.data.refreshToken);
              resolve(result.data);
            } else {
              reject(response.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    
    getUserProfile ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .getUserProfile(data)
          .then(response => {
            let result = response.data;
            if (!result.error) {
              let profile = result.data;
              resolve(profile);
            } else {
              reject(response.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    
    getInternalApp ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .getInternalApp(data)
          .then(response => {
            let result = response.data;
            if (!result.error) {
              resolve(result.data);
            } else {
              reject(result.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    addRoles ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .addRoles(data)
          .then(response => {
            let result = response.data;
            if (!result.code) {
              resolve(result.data);
            } else {
              reject(result.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    removeRoles ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .removeRoles(data)
          .then(response => {
            let result = response.data;
            if (!result.code) {
              resolve(result.data);
            } else {
              reject(result.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    addGroupRole ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .addGroupRole(data)
          .then(response => {
            let result = response.data;
            if (!result.code) {
              resolve(result.data);
            } else {
              reject(result.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js